export const pricing = {
  hero: {
    title: 'Transparent Pricing, No Surprises',
    subtitle: 'Choose the plan that best fits your business. All plans include 14-day free trial.'
  },
  plans: {
    starter: {
      name: 'Starter',
      price: '€99',
      period: '/month',
      description: 'Perfect for small businesses starting with automation',
      features: [
        'Up to 100 appointments/month',
        'AI voice assistant',
        'WhatsApp and email',
        'Basic calendar',
        'Automatic reminders',
        'Email support'
      ],
      cta: 'Start Free Trial'
    },
    professional: {
      name: 'Professional',
      price: '€249',
      period: '/month',
      description: 'For growing businesses that need more power',
      features: [
        'Up to 500 appointments/month',
        'Everything in Starter',
        'Multi-channel (phone, SMS, WhatsApp)',
        'Advanced calendar',
        'Analytics and reports',
        'CRM integrations',
        'Priority support'
      ],
      cta: 'Start Free Trial',
      popular: 'Most Popular'
    },
    enterprise: {
      name: 'Enterprise',
      price: 'Custom',
      period: '',
      description: 'Custom solutions for large businesses and chains',
      features: [
        'Unlimited appointments',
        'Everything in Professional',
        'Multiple locations',
        'Custom API',
        'Dedicated account manager',
        'Custom training',
        '24/7 support',
        'SLA guaranteed'
      ],
      cta: 'Contact Sales'
    }
  },
  comparison: {
    title: 'Detailed Comparison',
    subtitle: 'All features at a glance',
    features: {
      appointments: 'Monthly appointments',
      aiAssistant: 'AI voice assistant',
      channels: 'Communication channels',
      calendar: 'Calendar',
      reminders: 'Automatic reminders',
      analytics: 'Analytics',
      integrations: 'Integrations',
      support: 'Support',
      locations: 'Multiple locations',
      api: 'Custom API',
      training: 'Training',
      sla: 'SLA'
    },
    values: {
      basic: 'Basic',
      advanced: 'Advanced',
      complete: 'Complete',
      email: 'Email',
      priority: 'Priority',
      dedicated: 'Dedicated 24/7',
      included: 'Included',
      custom: 'Custom',
      yes: 'Yes',
      no: 'No'
    }
  },
  faq: {
    title: 'Frequently Asked Questions',
    question1: {
      q: 'Can I change plans at any time?',
      a: 'Yes, you can upgrade or downgrade your plan at any time. Changes take effect immediately and we adjust billing proportionally.'
    },
    question2: {
      q: 'What happens if I exceed my appointment limit?',
      a: 'We will notify you when you reach 80% of your limit. You can upgrade your plan or pay a small additional fee per extra appointment.'
    },
    question3: {
      q: 'Is there a setup fee?',
      a: 'No. All plans include free setup and configuration. We only charge the monthly subscription.'
    },
    question4: {
      q: 'Can I cancel at any time?',
      a: 'Yes, there are no permanence contracts. You can cancel your subscription at any time from your control panel.'
    },
    question5: {
      q: 'Do you offer discounts for annual payment?',
      a: 'Yes, if you pay annually you get 2 months free (equivalent to 16% discount).'
    }
  },
  cta: {
    title: 'Ready to Transform Your Business?',
    subtitle: 'Start your 14-day free trial. No credit card required.',
    button: 'Start Free Trial'
  }
};
